const extras = [
    { localisedLabel: 'menu.extras.name_public', key: "name_public" },
    { localisedLabel: 'menu.extras.quantity_min_list_header', key: "quantity_min" },
    { localisedLabel: 'menu.extras.quantity_max_list_header', key: "quantity_max" },
    { localisedLabel: '', key: "action_bulk_to_menu_items" },
    // { localisedLabel: 'menu.extras.inGroup', key: "inGroup" },
];

export default extras;